import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@openmrs/esm-root-config");
